// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-analytics-page {
  padding-left: 8%;
  overflow: auto;
  max-height: 90vh;
  height: 100%;
  width: 85%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dashboard-analytics-page__title {
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 0rem;
  display: flex;
  margin-top: 4rem;
}
.dashboard-analytics-page .chip {
  border: 0.0825rem solid #E3E8EC;
  color: #EE926B;
  font-weight: 500;
  background-color: #fff;
}
.dashboard-analytics-page__button-container {
  height: 3rem;
  width: 1015px;
  justify-content: flex-start;
  margin-top: 4rem;
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.dashboard-analytics-page__button-container__button {
  width: 14rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 214, 166, 0.4196078431);
  cursor: pointer;
}
.dashboard-analytics-page__button-container__button:last-child {
  margin-left: 90px;
}
.dashboard-analytics-page table {
  height: fit-content;
  border-collapse: collapse;
  width: 70%;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
}
.dashboard-analytics-page th {
  border: 0.0625rem solid #ddd;
  padding: 0.67rem;
  border-top: none;
}
.dashboard-analytics-page th:first-child {
  border-left: none;
}
.dashboard-analytics-page th:last-child {
  border-right: none;
}
.dashboard-analytics-page td {
  border-left: 0.0625rem solid #ddd;
  border-right: 0.0625rem solid #ddd;
  padding: 1rem;
  text-align: center;
  width: 100px;
  text-wrap: nowrap;
}
.dashboard-analytics-page td:first-child {
  border-left: none;
}
.dashboard-analytics-page th {
  color: #666;
  font-size: 0.8125rem;
  font-weight: 500;
  min-width: fit-content;
}
.dashboard-analytics-page .modify {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

/* Override the calendar input field */`, "",{"version":3,"sources":["webpack://./src/features/admin/components/dashboard-analytics/dashboard-analytics.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAI;EACE,iBAAA;EACF,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AAAQ;EACE,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEV;AAAQ;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEV;AADU;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;AAGZ;AAFY;EACE,iBAAA;AAId;AACQ;EACI,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AACZ;AAEU;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AAAZ;AACY;EACI,iBAAA;AAChB;AACY;EACI,kBAAA;AAChB;AAEU;EACE,iCAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAAZ;AAEY;EACI,iBAAA;AAAhB;AAIU;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AAFZ;AAIU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AAFZ;;AAKQ,sCAAA","sourcesContent":[".dashboard-analytics-page{\n    padding-left: 8%;\n    overflow: auto;\n    max-height: 90vh;\n    height: 100%;\n    width: 85%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    &__title{\n      font-size: 2.5rem;\n    font-weight: 500;\n    margin-bottom: 0rem;\n    display: flex;\n    margin-top: 4rem;\n    }\n        .chip{\n          border: 0.0825rem solid #E3E8EC;\n          color:#EE926B;\n          font-weight: 500;\n          background-color: #fff;\n        }\n        &__button-container{\n          height: 3rem;\n          width: 1015px;  \n          justify-content: flex-start;    \n          margin-top: 4rem;\n          display: flex;\n          flex-direction: row;\n          gap: 20px;\n          &__button{\n            width: 14rem;\n            height: 2rem;\n            border-radius: 5px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: #FFD6A66B;\n            cursor: pointer;\n            &:last-child{\n              margin-left: 90px;\n            }\n          }\n\n        }\n        table {\n            height: fit-content;\n            border-collapse: collapse;\n            width: 70%;\n            box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);\n            margin-bottom: 20px;\n          }\n          \n          th {\n            border: 0.0625rem solid #ddd;\n            padding: 0.67rem;\n            border-top: none;\n            &:first-child {\n                border-left: none;\n            }\n            &:last-child {\n                border-right: none;\n            }\n          }\n          td {\n            border-left: 0.0625rem solid #ddd;\n            border-right: 0.0625rem solid #ddd;\n            padding: 1rem;\n            text-align: center;\n            width:100px;\n            text-wrap: nowrap;\n          \n            &:first-child {\n                border-left: none;\n            }\n          }\n          \n          th {\n            color: #666;\n            font-size: 0.8125rem;\n            font-weight: 500;\n            min-width: fit-content;\n          }\n          .modify{\n            cursor: pointer;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-around;\n            align-items: center;\n            height: 100%;\n          }\n        }\n        /* Override the calendar input field */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
